export default __webpack_public_path__ + "static/media/iconInbound.68c499f7.svg";